import { useState } from 'react';
import { Node } from '../classes/CircularLinkedList';
import Individual from '../types/individual';

export default function useZoom() {
  const [zoomOpen, setZoomOpen] = useState(false);
  const [carouselNode, setCarouselNode] = useState<Node<Individual> | null>(null);

  const showZoom = (node: Node<Individual> | null) => {
    if (node) {
      setCarouselNode(node);
      setZoomOpen(true);
    }
  };

  const closeZoom = () => {
    setZoomOpen(false);
  };

  return { zoomOpen, carouselNode, setCarouselNode, showZoom, closeZoom };
}

